export default (node) => {
  const priceProductId = node.dataset.productId;

  const handleVariantChange = (event) => {
    const { variant, productId } = event.detail;
    if (productId !== priceProductId) return;
    node.textContent = variant.price;
  };

  const init = () => {
    document.addEventListener('variant:change', handleVariantChange);
  };

  init();
};
